import RoomDetails from './RoomDetails.component';
export default RoomDetails;